// =============================================================================
// tasumo-product.js
// バリアント切替時の購入UI切替
// =============================================================================

(function () {
  'use strict';

  const dataEl = document.getElementById('tasumo-variants-data');
  if (!dataEl) return;

  let variantsData;
  try {
    variantsData = JSON.parse(dataEl.textContent);
  } catch (e) {
    console.warn('[tasumo-product] failed to parse variants data', e);
    return;
  }

  const purchaseEl = document.querySelector('.tasumo-hero__purchase');
  if (!purchaseEl) return;

  const subscriptionEl = purchaseEl.querySelector('[data-tasumo-subscription]');
  const standardEl = purchaseEl.querySelector('[data-tasumo-standard]');
  const idInput = purchaseEl.querySelector('[data-product-form-id-input]');

  let _dispatching = false;

  function findVariant(id) {
    return variantsData.find(function (v) { return String(v.id) === String(id); });
  }

  function updateUI(variantId) {
    if (_dispatching) return;

    const variant = findVariant(variantId);
    if (!variant) return;

    if (variant.has_subscription) {
      if (subscriptionEl) subscriptionEl.hidden = false;
      // available:false = 定期限定バリアント → 標準カートを隠す
      if (standardEl) standardEl.hidden = !variant.available;
    } else {
      if (subscriptionEl) subscriptionEl.hidden = true;
      if (standardEl) standardEl.hidden = false;
    }

    purchaseEl.dataset.currentVariantId = variantId;

    // バリアント別画像切替
    var variantImagesScript = document.getElementById('tasumo-variant-images-data');
    if (variantImagesScript) {
      try {
        var variantImages = JSON.parse(variantImagesScript.textContent);
        var url = variantImages[variantId];
        var mainImage = document.querySelector('[data-tasumo-main-image]');
        if (url && mainImage) {
          mainImage.src = url;
          var thumbs = document.querySelectorAll('[data-tasumo-thumb]');
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumbs.forEach(function (t) {
            if (t.dataset.imageUrl === url) {
              t.classList.add('is-active');
            }
          });
        }
      } catch (e) {
        console.warn('[tasumo-product] variant image switch failed', e);
      }
    }

    // ハックルベリー等の外部JSにバリアント変更を通知
    _dispatching = true;
    try {
      // form の input[name="id"] を全て更新して change/input イベントを発火
      document.querySelectorAll('input[name="id"]').forEach(function (input) {
        if (input.value !== String(variantId)) {
          input.value = variantId;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });

      document.dispatchEvent(new CustomEvent('variant:change', {
        detail: { variant: { id: parseInt(variantId, 10) } },
        bubbles: true
      }));
      window.dispatchEvent(new CustomEvent('product:variant_change', {
        detail: { variantId: variantId },
        bubbles: true
      }));
      if (window.jQuery) {
        window.jQuery(document).trigger('variant.changed', [variantId]);
      }
    } finally {
      _dispatching = false;
    }
  }

  // =============================================================================
  // Variant radio change → hidden input update + updateUI
  // =============================================================================
  (function initVariantSwitcher() {
    const radios = document.querySelectorAll(
      '.tasumo-hero__variants input[type="radio"], variant-selects input[type="radio"]'
    );
    if (!radios.length) return;

    const hiddenInput = document.querySelector('[data-product-form-id-input]');
    if (!hiddenInput) {
      console.warn('[tasumo] hidden input not found');
      return;
    }

    radios.forEach(function (radio, idx) {
      radio.addEventListener('change', function () {
        if (!this.checked) return;

        const variant = variantsData[idx];
        if (!variant) {
          console.warn('[tasumo] variant not found at index', idx);
          return;
        }

        hiddenInput.value = variant.id;
        updateUI(variant.id);

        hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
        hiddenInput.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });

    const checked = Array.from(radios).find(function (r) { return r.checked; });
    if (checked) {
      const idx = Array.from(radios).indexOf(checked);
      const variant = variantsData[idx];
      if (variant) hiddenInput.value = variant.id;
    }
  }());

  // =============================================================================
  // Price display sync (variant + Huckleberry plan combination)
  // =============================================================================
  (function initPriceSync() {
    const priceEl = document.querySelector('[data-tasumo-price-value]');
    const subNoticeEl = document.querySelector('[data-tasumo-price-subscription-notice]');
    const subNoticeMinEl = document.querySelector('[data-tasumo-price-subscription-min]');
    if (!priceEl) return;

    function updatePriceDisplay() {
      const variantId = document.querySelector('[data-product-form-id-input]') && document.querySelector('[data-product-form-id-input]').value;
      if (!variantId) return;

      const variant = variantsData.find(function(v) { return String(v.id) === String(variantId); });
      if (!variant) {
        console.warn('[tasumo] variant not found:', variantId);
        return;
      }

      // DOMから現在の状態を直接読む
      const planChecked = document.querySelector(
        '.huckleberry-subscription-widget-container input[name="plan"]:checked'
      );
      const optionChecked = document.querySelector(
        '.huckleberry-subscription-widget-container input[name="planOption"]:checked'
      );

      const planType = planChecked ? planChecked.value : 'onetime';
      const optionId = optionChecked ? optionChecked.value : null;

      console.log('[updatePriceDisplay]', { planType: planType, optionId: optionId, variantId: variantId });

      // メイン価格決定
      var displayPrice = variant.price_formatted;

      if (planType === 'subscription' && optionId && variant.selling_plan_prices) {
        var subPrice = variant.selling_plan_prices[optionId];
        if (subPrice) displayPrice = subPrice;
      }

      console.log('[updatePriceDisplay] displayPrice:', displayPrice);

      priceEl.textContent = displayPrice;

      // 「定期便なら〜から」表示
      if (subNoticeEl && subNoticeMinEl) {
        var showNotice = (
          planType !== 'subscription' &&
          variant.has_subscription &&
          variant.min_subscription_price_formatted &&
          variant.min_subscription_price < variant.price
        );

        subNoticeEl.hidden = !showNotice;
        if (showNotice) subNoticeMinEl.textContent = variant.min_subscription_price_formatted;
      }
    }

    function handleHuckleberryEvent(e) {
      if (!e.target.closest('.huckleberry-subscription-widget-container')) return;
      setTimeout(updatePriceDisplay, 0);
    }

    document.addEventListener('change', handleHuckleberryEvent);
    document.addEventListener('click', handleHuckleberryEvent);

    document.addEventListener('variant:change', updatePriceDisplay);

    updatePriceDisplay();
  }());

  // 初期表示
  const initialId = purchaseEl.dataset.currentVariantId;
  if (initialId) updateUI(initialId);

  // パターン1: Riseテーマのカスタムイベント variant:change
  document.addEventListener('variant:change', function (e) {
    const variantId = e.detail && e.detail.variant && e.detail.variant.id;
    if (variantId) updateUI(variantId);
  });

  // パターン2: form内の input[name="id"] 変更を監視
  document.addEventListener('change', function (e) {
    if (e.target.matches('input[name="id"]')) {
      updateUI(e.target.value);
    }
  });

  // パターン3: バリアントピッカーのUI操作後に少し待ってidInputを読む
  document.addEventListener('change', function (e) {
    if (e.target.closest('.tasumo-hero__variants')) {
      setTimeout(function () {
        const currentId = idInput && idInput.value;
        if (currentId) updateUI(currentId);
      }, 50);
    }
  });
})();

// =============================================================================
// Huckleberry ウィジェット文言カスタマイズ
// =============================================================================
(function () {
  'use strict';

  var LABEL_MAP = {
    '定期決済': 'お得定期便',
    '一回決済': '通常配送'
  };

  function replaceLabels(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var original = node.nodeValue;
      var replaced = original;
      Object.keys(LABEL_MAP).forEach(function (from) {
        replaced = replaced.replace(new RegExp(from, 'g'), LABEL_MAP[from]);
      });
      if (replaced !== original) node.nodeValue = replaced;
    }
  }

  var container = document.querySelector('.huckleberry-subscription-widget-container');
  if (!container) return;

  replaceLabels(container);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) replaceLabels(node);
      });
    });
  }).observe(container, { childList: true, subtree: true });
}());

// =============================================================================
// Hero Gallery (thumbnail click → main image swap)
// =============================================================================
(function () {
  'use strict';

  const thumbs = document.querySelectorAll('[data-tasumo-thumb]');
  const mainImage = document.querySelector('[data-tasumo-main-image]');
  if (!thumbs.length || !mainImage) return;

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      const url = this.dataset.imageUrl;
      if (!url) return;

      mainImage.src = url;
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      this.classList.add('is-active');
    });
  });
})();

// =============================================================================
// Video preview start position
// =============================================================================
(function () {
  'use strict';

  var video = document.querySelector('.tasumo-video__player video');
  if (!video) return;

  video.addEventListener('loadedmetadata', function () {
    video.currentTime = 2;
  });
}());
